module.exports = __webpack_public_path__ + "img/sq.c70015e2.webp";